<div class="p-4 rounded-xl">

  <div class="flex items-center justify-between mb-4">
    <div class="flex items-center gap-4">
      <app-back-button></app-back-button>
      <h2 class="text-lg font-semibold">{{ 'SETUP.ORG.TEAM_LEAD' | translate }}</h2>
    </div>

    <button class="btn-primary" (click)="openPopup()">
      {{ 'SETUP.ADD_PLUS' | translate }}
    </button>
  </div>

  <app-table
    [columns]="columns"
    [data]="list"
    [actions]="actions"
  ></app-table>

  <app-popup
    [(show)]="showPopup"
    title="SETUP.ORG.TEAM_LEAD"
    [fields]="fields"
    [data]="formData"
    [onSave]="handleSave"
    type="form"
  ></app-popup>

  <app-popup
    [(show)]="showAssignPopup"
    title="SETUP.EMPLOYEE_ASSIGNMENT"
    [fields]="assignFields"
    [data]="assignFormData"
    [onSave]="handleAssignSave"
    saveLabel="COMMON.OK"
    type="form"
  ></app-popup>

  <app-popup
    [(show)]="showDeletePopup"
    title="SETUP.ORG.DELETE_TEAM_LEAD"
    type="confirm"
    [message]="deleteMessage"
    confirmText="COMMON.DELETE"
    cancelText="COMMON.CANCEL"
    (confirmed)="confirmDelete()">
  </app-popup>

</div>
